import { useMutation } from "@tanstack/react-query";
import api from "../../services/api";
import { useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";

export default function Register() {
  const navigate = useNavigate();

  const registerMutation = useMutation({
    mutationFn: (data) => api.post("/auth/register", data),
    onSuccess: (res) => {
      localStorage.setItem("token", res.data.token);
      Swal.fire({
        icon: "success",
        title: "Registration Successful!",
        text: "Your account has been created successfully.",
        confirmButtonColor: "#6366f1",
        timer: 2000,
        showConfirmButton: true,
      }).then(() => {
        navigate("/admin/products");
      });
    },
  });

  const submit = (e) => {
    e.preventDefault();
    registerMutation.mutate({
      name: e.target.name.value,
      email: e.target.email.value,
      password: e.target.password.value,
    });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="bg-white rounded-2xl shadow-lg p-10 w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Create Account</h1>
          <p className="text-gray-600 text-sm">Sign up to access the admin panel</p>
        </div>

        {registerMutation.isError && (
          <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm mb-6">
            {registerMutation.error?.response?.data?.message || "Registration failed. Please try again."}
          </div>
        )}

        <form className="space-y-6" onSubmit={submit}>
          <div className="space-y-2">
            <label htmlFor="name" className="block text-sm font-semibold text-gray-700">Full Name</label>
            <input
              id="name"
              name="name"
              type="text"
              placeholder="Enter your full name"
              required
              className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:outline-none focus:border-gray-500 focus:ring-2 focus:ring-gray-200 transition-all"
            />
          </div>

          <div className="space-y-2">
            <label htmlFor="email" className="block text-sm font-semibold text-gray-700">Email</label>
            <input
              id="email"
              name="email"
              type="email"
              placeholder="Enter your email"
              required
              className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:outline-none focus:border-gray-500 focus:ring-2 focus:ring-gray-200 transition-all"
            />
          </div>

          <div className="space-y-2">
            <label htmlFor="password" className="block text-sm font-semibold text-gray-700">Password</label>
            <input
              id="password"
              name="password"
              type="password"
              placeholder="Enter your password"
              required
              minLength={6}
              className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:outline-none focus:border-gray-500 focus:ring-2 focus:ring-gray-200 transition-all"
            />
          </div>

          <button
            type="submit"
            className="w-full bg-gray-800 hover:bg-gray-900 text-white py-3 px-6 rounded-lg font-semibold shadow-md hover:shadow-lg transition-all disabled:opacity-60 disabled:cursor-not-allowed"
            disabled={registerMutation.isPending}
          >
            {registerMutation.isPending ? "Creating Account..." : "Sign Up"}
          </button>
        </form>

        <div className="text-center mt-6 pt-6 border-t border-gray-200 text-sm text-gray-600">
          Already have an account? <Link to="/admin/login" className="text-gray-800 font-semibold hover:underline">Sign In</Link>
        </div>
      </div>
    </div>
  );
}
